import dayjs from "dayjs";
import IRestaurant from "shared/interfaces/Restaurant.interface";

import { getIncludedTimesForDate } from ".";

export default (restaurant: IRestaurant) => {
  const dates = getIncludedTimesForDate(restaurant, dayjs().toDate());
  return dates[dates.length - 1];
};
